import { connect } from 'react-redux';
import { Action, bindActionCreators, Dispatch } from 'redux';

import { logout } from 'redux/actions/auth';
import { toggleUserProfile } from 'redux/actions/users';
import { selectUser, selectUserType, selectIsBlocked } from 'redux/selectors/auth';
import { selectToggleUserProfile } from 'redux/selectors/users';
import { StateType } from 'types';

const mapStateToProps = (state: StateType) => ({
  loggedInUser: selectUser(state),
  userType: selectUserType(state),
  isVisible: selectToggleUserProfile(state),
  isBlocked: selectIsBlocked(state),
});

const mapDispatchToProps = (dispatch: Dispatch<Action>) => ({
  actions: bindActionCreators({
    logout,
    toggleUserProfile,
  }, dispatch),
});

export default connect(mapStateToProps, mapDispatchToProps);
